module.exports = __webpack_public_path__ + "img/plug5.12d3a7be.jpg";